/* ===================== 求肥屋 theme.js ===================== */
(function () {
  /* ---------- header solid on scroll ---------- */
  var hdr = document.getElementById('hdr');
  if (hdr) {
    addEventListener('scroll', function () {
      hdr.classList.toggle('solid', scrollY > 40);
    }, { passive: true });
  }

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.16 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---------- mobile menu ---------- */
  var mmenu = document.getElementById('mmenu');
  var burger = document.getElementById('burger');
  window.toggleMenu = function (open) {
    if (!mmenu) return;
    mmenu.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  if (burger) burger.onclick = function () { toggleMenu(true); };

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var fmt = function (cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  };

  window.openCart = function () {
    if (!drawer) { location.href = window.routes.cart_url; return; }
    drawer.classList.add('open'); scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  };
  window.closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.classList.remove('open');
    document.body.style.overflow = '';
  };
  var cartOpen = document.getElementById('cartOpen');
  if (cartOpen) cartOpen.onclick = openCart;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- add to cart (event delegation) ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-add-to-cart]');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    var label = btn.textContent;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.add('done'); btn.textContent = '追加しました';
        setTimeout(function () { btn.classList.remove('done'); btn.textContent = label; btn.disabled = false; }, 1300);
        openCart();
      })
      .catch(function () { btn.disabled = false; });
  });

  /* ---------- change qty / remove ---------- */
  window.changeQty = function (key, qty) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  };

  function fetchCart() {
    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function renderCart(cart) {
    var body = document.getElementById('cartBody');
    setCount(cart.item_count);
    var sub = document.getElementById('subtotal');
    var checkout = document.getElementById('checkout');
    if (sub) sub.textContent = fmt(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty">カートは空です。<br>静かな贅沢を、ひと匙どうぞ。</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_120x$1') : '';
      return '<div class="ci">' +
        '<img src="' + img + '" alt="">' +
        '<div><div class="nm">' + it.product_title + '</div>' +
        '<div class="pr">' + fmt(it.final_price) + ' 税込</div>' +
        '<div class="qty"><button onclick="changeQty(\'' + it.key + '\',' + (it.quantity - 1) + ')">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button onclick="changeQty(\'' + it.key + '\',' + (it.quantity + 1) + ')">＋</button></div></div>' +
        '<button class="rm" onclick="changeQty(\'' + it.key + '\',0)">削除</button>' +
        '</div>';
    }).join('');
  }

  window.checkout = function () { location.href = '/checkout'; };

  /* initial count */
  fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { setCount(c.item_count); });
})();
